module.exports = __webpack_public_path__ + "static/media/burger_Logo.b8503d26.png";